import { render, staticRenderFns } from "./TeamLeave.vue?vue&type=template&id=8b2d37f8"
import script from "./TeamLeave.vue?vue&type=script&lang=js"
export * from "./TeamLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports